import {ActionProgressState} from "../../../action-manager/action/action-progress-state";

export class BackupRestoreProgress extends ActionProgressState {

  public id: number;
  public websiteId: number;
  public backupId: string;
  public status: string;
  public active: boolean;
  public creationDate: Date;
  public updatedDate: Date;

}
